import { api } from "@/service";
import type { TDocument } from "@/types";
import { AxiosError } from "axios";

export class DocumentService {
   async addDocument(
      slug: string,
      payload: Pick<TDocument, "userId" | "type" | "images" | "number">,
   ) {
      return api
         .post<TDocument>(`/workspaces/${slug}/documents`, payload)
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
   async deleteDocument(slug: string, id: number) {
      return api
         .delete<never>(`/workspaces/${slug}/documents/${id}`)
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
}
